export default class Step {
    constructor(num, ops, stack, operator, operands, error, result) {
        this.num = num;
        this.ops = ops;
        this.stack = stack;
        this.operator = operator;
        this.operands = operands;
        this.result = result;
        this.error = error;
    }

    clone() {
        return new Step(this.num, this.ops, this.stack, this.operator, this.operands, this.error, this.result);
    }
}